import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "rapida-popup" }
const _hoisted_2 = { class: "rapida-coduri-section" }
const _hoisted_3 = {
  key: 0,
  class: "rapida-status"
}
const _hoisted_4 = { class: "rapida-results-section" }
const _hoisted_5 = { class: "rapida-results-caption" }
const _hoisted_6 = {
  key: 0,
  class: "rapida-badge-ok"
}
const _hoisted_7 = {
  key: 1,
  class: "rapida-badge-err"
}
const _hoisted_8 = { class: "rapida-table-scroll" }
const _hoisted_9 = { class: "rapida-table" }
const _hoisted_10 = { class: "rapida-status-cell" }
const _hoisted_11 = { class: "rapida-cod-cell" }
const _hoisted_12 = { class: "rapida-den-cell" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "rapida-negasit"
}
const _hoisted_15 = { class: "rapida-input-cell" }
const _hoisted_16 = { class: "rapida-input-cell" }
const _hoisted_17 = {
  key: 1,
  class: "rapida-empty-state"
}

import { ref, computed, watch, nextTick } from 'vue';
import DxPopup, { DxToolbarItem } from 'devextreme-vue/popup';
import DxNumberBox from 'devextreme-vue/number-box';
import notify from 'devextreme/ui/notify';
import http from '@/settings/apiSettings';
import DOC_Linii from '@/services/Documente/DOC_Linii';

interface DocumentProp {
    Id?: string;
    [key: string]: unknown;
}

interface ImportLinie {
    cod: string;
    produs: any | null;
    gasit: boolean;
    cantitate: number;
    pretUnitar: number | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PopupImportLiniiExcel',
  props: {
    document: {},
    visible: { type: Boolean }
  },
  emits: ["update:visible", "linii-added"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const coduri = ref('');
const linii = ref<ImportLinie[]>([]);
const isProcessing = ref(false);
const isAdaugand = ref(false);
const textareaRef = ref<HTMLTextAreaElement | null>(null);

const liniiGasite = computed(() => linii.value.filter((l) => l.gasit));
const liniiNegasite = computed(() => linii.value.filter((l) => !l.gasit));

function formatRO(val: number | null | undefined): string {
    if (val == null) return '';
    return val.toLocaleString('ro-RO', { maximumFractionDigits: 10 });
}

function getErrMsg(err: any): string {
    const data = err?.response?.data;
    if (data) {
        if (typeof data === 'string') return data;
        if (data.error?.message) return data.error.message;
        if (data.message) return data.message;
        if (data.title) return data.title;
    }
    return err?.message ?? 'A apărut o eroare.';
}

let debounceTimer: ReturnType<typeof setTimeout> | null = null;
watch(coduri, (val) => {
    if (!val.trim()) { linii.value = []; return; }
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => proceseazaCoduri(), 500);
});

watch(() => props.visible, (val) => {
    if (val) {
        coduri.value = '';
        linii.value = [];
        nextTick(() => textareaRef.value?.focus());
    }
});

async function proceseazaCoduri() {
    const listaCoduri = coduri.value.split('\n').map((c) => c.trim()).filter((c) => c.length > 0);
    if (listaCoduri.length === 0) { linii.value = []; return; }
    isProcessing.value = true;
    try {
        // Deduplicare păstrând ordinea/case-ul original — la fel ca la Comenzi.
        const seenLower = new Set<string>();
        const unice: string[] = [];
        for (const cod of listaCoduri) {
            if (!seenLower.has(cod.toLowerCase())) {
                seenLower.add(cod.toLowerCase());
                unice.push(cod);
            }
        }

        // Interogare în loturi mici — fiecare cod adaugă ~5-6 noduri la $filter (2x "eq" + "or" +
        // conectorul dintre grupuri), iar OData respinge peste 100 de noduri per query (implicit
        // ASP.NET OData). Loturi de 10 coduri rămân sigur sub prag indiferent câte coduri se lipesc.
        const LOT_SIZE = 10;
        const loturi: string[][] = [];
        for (let i = 0; i < unice.length; i += LOT_SIZE) {
            loturi.push(unice.slice(i, i + LOT_SIZE));
        }

        const raspunsuri = await Promise.all(
            loturi.map((lot) => {
                const filterStr = lot
                    .map((c) => `(Cod eq '${c.replace(/'/g, "''")}' or CodIntern eq '${c.replace(/'/g, "''")}')`)
                    .join(' or ');
                return http.clientDocumenteOdata.get('PRO_Produse', {
                    params: {
                        '$filter': filterStr,
                        '$select': 'Id,Cod,CodIntern,Nume,UnitateId,CategorieContabilaId',
                    },
                });
            })
        );
        const produse: any[] = raspunsuri.flatMap((resp) => resp.data?.value ?? []);

        linii.value = listaCoduri.map((cod) => {
            const produs = produse.find((p) =>
                p.Cod?.toLowerCase() === cod.toLowerCase() ||
                p.CodIntern?.toLowerCase() === cod.toLowerCase()
            ) ?? null;
            return {
                cod,
                produs,
                gasit: !!produs,
                cantitate: 1,
                pretUnitar: null,
            };
        });
    } catch (err: any) {
        notify(getErrMsg(err), 'error', 3000);
        linii.value = listaCoduri.map((cod) => ({ cod, produs: null, gasit: false, cantitate: 1, pretUnitar: null }));
    } finally {
        isProcessing.value = false;
    }
}

function close() {
    emit('update:visible', false);
}

async function onAdaugaToate() {
    const gasite = liniiGasite.value;
    if (gasite.length === 0 || !props.document?.Id) return;
    isAdaugand.value = true;
    let adaugate = 0;
    try {
        for (const linie of gasite) {
            await DOC_Linii.save(props.document.Id, {
                ProdusId: linie.produs.Id,
                ProdusNume: linie.produs.Nume ?? null,
                UnitateId: linie.produs.UnitateId ?? null,
                CategorieContabilaId: linie.produs.CategorieContabilaId ?? null,
                Cantitate: linie.cantitate ?? 1,
                PretUnitar: linie.pretUnitar ?? null,
            });
            adaugate++;
        }
        notify(`${adaugate} linie(i) adăugate cu succes.`, 'success', 2000);
        emit('linii-added');
        coduri.value = '';
        linii.value = [];
        close();
    } catch (err: any) {
        if (adaugate > 0) {
            emit('linii-added');
            notify(`${adaugate} din ${gasite.length} linii adăugate. ${getErrMsg(err)}`, 'warning', 5000);
        } else {
            notify(getErrMsg(err), 'error', 3000);
        }
    } finally {
        isAdaugand.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxPopup), {
    visible: __props.visible,
    "show-title": false,
    "drag-enabled": true,
    "show-close-button": false,
    "close-on-outside-click": false,
    width: 1000,
    height: 620,
    "wrapper-attr": { class: 'import-linii-excel-popup' },
    onHidden: close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { class: "ehp-header" }, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ehp-header-main" }, [
            _createElementVNode("i", { class: "dx-icon dx-icon-xlsxfile ehp-icon" }),
            _createElementVNode("div", { class: "ehp-texts" }, [
              _createElementVNode("span", { class: "ehp-title" }, "Import linii din Excel"),
              _createElementVNode("span", { class: "ehp-subtitle" }, "Lipiți coduri — câte unul pe linie")
            ])
          ], -1)),
          _createElementVNode("span", {
            class: "ehp-close",
            onClick: close
          }, "×")
        ]),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("textarea", {
            ref_key: "textareaRef",
            ref: textareaRef,
            class: "rapida-textarea",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((coduri).value = $event)),
            placeholder: "Lipiți coduri cu Ctrl+V — câte unul pe linie...",
            rows: "4"
          }, null, 512), [
            [_vModelText, coduri.value]
          ]),
          (isProcessing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Se procesează..."))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (linii.value.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[2] || (_cache[2] = _createTextVNode(" Rezultate ", -1)),
                  (liniiGasite.value.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(liniiGasite.value.length) + " găsite", 1))
                    : _createCommentVNode("", true),
                  (liniiNegasite.value.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(liniiNegasite.value.length) + " negăsite", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("table", _hoisted_9, [
                    _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { style: {"width":"28px"} }),
                        _createElementVNode("th", { style: {"width":"110px"} }, "Cod"),
                        _createElementVNode("th", { style: {"min-width":"160px"} }, "Denumire"),
                        _createElementVNode("th", { style: {"width":"100px"} }, "Cantitate"),
                        _createElementVNode("th", { style: {"width":"120px"} }, "Preț Unitar")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linii.value, (linie, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: i,
                          class: _normalizeClass(linie.gasit ? 'rapida-row-ok' : 'rapida-row-err')
                        }, [
                          _createElementVNode("td", _hoisted_10, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["dx-icon", linie.gasit ? 'dx-icon-check' : 'dx-icon-close'])
                            }, null, 2)
                          ]),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(linie.cod), 1),
                          _createElementVNode("td", _hoisted_12, [
                            (linie.gasit)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(linie.produs.Nume), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_14, "Nu a fost găsit"))
                          ]),
                          _createElementVNode("td", _hoisted_15, [
                            (linie.gasit)
                              ? (_openBlock(), _createBlock(_unref(DxNumberBox), {
                                  key: 0,
                                  value: linie.cantitate,
                                  "onUpdate:value": ($event: any) => ((linie.cantitate) = $event),
                                  min: 0.0001,
                                  format: formatRO,
                                  width: "100%"
                                }, null, 8, ["value", "onUpdate:value"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_16, [
                            (linie.gasit)
                              ? (_openBlock(), _createBlock(_unref(DxNumberBox), {
                                  key: 0,
                                  value: linie.pretUnitar,
                                  "onUpdate:value": ($event: any) => ((linie.pretUnitar) = $event),
                                  min: 0,
                                  format: formatRO,
                                  width: "100%"
                                }, null, 8, ["value", "onUpdate:value"]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", {
                  class: "dx-icon dx-icon-paste",
                  style: {"font-size":"32px","color":"#cbd5e1","margin-bottom":"10px"}
                }, null, -1),
                _createElementVNode("span", null, "Lipiți coduri în câmpul de mai sus (Ctrl+V)", -1)
              ]))]))
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: isAdaugand.value ? 'Se adaugă...' : `Adaugă ${liniiGasite.value.length} linie(i)`, type: 'default', disabled: isAdaugand.value || liniiGasite.value.length === 0, onClick: onAdaugaToate }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: 'Închide', stylingMode: 'outlined', onClick: close }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})